/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISpecialityVitals } from 'app/shared/model/speciality-vitals.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ISpecVitalResult {
  id?: string;
  observation?: string | null;
  comments?: string | null;
  eventId?: string | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof AddedByType | null;
  modifiedByType?: keyof typeof AddedByType | null;
  active?: boolean | null;
  cursor?: number;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  EventType?: string | null;
  specVital?: ISpecialityVitals | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<ISpecVitalResult> = {
  active: false,
};
